import React from "react";
import PropTypes from "prop-types";

const MenuSection = ({ className, children }) => (
  <div className={className}>
    <ul className="menu-item-list">{children}</ul>
  </div>
);

MenuSection.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};
export default React.memo(MenuSection);
